import axios from "axios";

export default class ApiService {


    // static BASE_URL = "http://localhost:8090/api";
    static BASE_URL = process.env.REACT_APP_BASE_URL; //production base url

    static saveToken(token) {
        localStorage.setItem("token", token);
    }

    static getToken() {
        return localStorage.getItem("token");
    }

    //save role
    static saveRole(roles) {
        localStorage.setItem("roles", JSON.stringify(roles));
    }

    // Get the roles from local storage
    static getRoles() {
        const roles = localStorage.getItem('roles');
        return roles ? JSON.parse(roles) : null;
    }

    // Check if the user has a specific role
    static hasRole(role) {
        const roles = this.getRoles();
        return roles ? roles.includes(role) : false;
    }

    // Check if the user is an admin
    static isAdmin() {
        return this.hasRole('ADMIN');
    }

    // Check if the user is an instructor
    static isCustomer() {
        return this.hasRole('CUSTOMER');
    }

    // Check if the user is a student
    static isDeliveryPerson() {
        return this.hasRole('DELIVERY');
    }


    static logout() {
        localStorage.removeItem("token");
        localStorage.removeItem("roles");
    }

    static isAthenticated() {
        const token = this.getToken();
        return !!token;
    }

    static getHeader() {
        const token = this.getToken();
        return {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    }






    


    // REGISTER USER
    static async registerUser(registrationData) {
        const resp = await axios.post(`${this.BASE_URL}/auth/register`, registrationData);
        return resp.data;
    }



    static async loginUser(loginData) {
        const resp = await axios.post(`${this.BASE_URL}/auth/login`, loginData);
        return resp.data;
    }











     /**USERS PROFILE MANAGEMENT SESSION */
    static async myProfile() {
        const resp = await axios.get(`${this.BASE_URL}/users/account`, {
            headers: this.getHeader()
        })
        return resp.data;
    }


    static async updateProfile(formData) {
        const resp = await axios.put(`${this.BASE_URL}/users/update`, formData, {
            headers: {
                ...this.getHeader(),
                'Content-Type': 'multipart/form-data'
            }
        });
        return resp.data;
    }


    static async deactivateProfile() {
        const resp = await axios.delete(`${this.BASE_URL}/users/deactivate`, {
            headers: this.getHeader()
        });
        return resp.data;
    }














    //ORDER SECTION

    static async placeOrder() {
        const resp = await axios.post(`${this.BASE_URL}/orders/checkout`, {}, {
            headers: this.getHeader()
        })
        return resp.data;
    }

    static async initiateDelivery(body) {
        const resp = await axios.post(`${this.BASE_URL}/orders/initiate-delivery`, body, {
            headers: this.getHeader()
        })
        return resp.data;
    }

    static async updateOrderStatus(body) {
        const resp = await axios.put(`${this.BASE_URL}/orders/update`, body, {
            headers: this.getHeader()
        })
        return resp.data;
    }


    static async getAllOrders(orderStatus, page = 0, size = 200) {

        let url = `${this.BASE_URL}/orders/all`;

        if (orderStatus) {
            url = `${this.BASE_URL}/orders/all?orderStatus=${orderStatus}&page=${page}&size=${size}`
        }

        const resp = await axios.get(url, {
            headers: this.getHeader()
        })
        return resp.data;

    }


    static async getMyOrders() {
        const resp = await axios.get(`${this.BASE_URL}/orders/me`, {
            headers: this.getHeader()
        })
        return resp.data;
    }


    static async getOrderById(id) {
        const resp = await axios.get(`${this.BASE_URL}/orders/${id}`, {
            headers: this.getHeader()
        })
        return resp.data;
    }


    static async countTotalActiveCustomers() {
        const resp = await axios.get(`${this.BASE_URL}/orders/unique-customers`, {
            headers: this.getHeader()
        })
        return resp.data;
    }


    static async getOrderItemById(id) {
        const resp = await axios.get(`${this.BASE_URL}/orders/order-item/${id}`, {
            headers: this.getHeader()
        })
        return resp.data;
    }













    /* CATEGORY SECTION */
    static async getAllCategories() {
        console.log("getAllCategories() was called")
        const resp = await axios.get(`${this.BASE_URL}/categories/all`);
        console.log("response is: " + resp.data)
        return resp.data;
    }

    static async getCategoryById(id) {
        const resp = await axios.get(`${this.BASE_URL}/categories/${id}`);
        return resp.data;
    }

    static async createCategory(body) {
        const resp = await axios.post(`${this.BASE_URL}/categories`, body, {
            headers: this.getHeader()
        });
        return resp.data;
    }

    static async updateCategory(body) {
        const resp = await axios.put(`${this.BASE_URL}/categories`, body, {
            headers: this.getHeader()
        });
        return resp.data;
    }

    static async deleteCategory(id) {
        const resp = await axios.delete(`${this.BASE_URL}/categories/${id}`, {
            headers: this.getHeader()
        });
        return resp.data;
    }











    /* MENU SECTION */

    static async addMenu(formData) {
        const resp = await axios.post(`${this.BASE_URL}/menu`, formData, {
            headers: {
                ...this.getHeader(),
                'Content-Type': 'multipart/form-data'
            }
        });
        return resp.data;
    }

    static async updateMenu(formData) {
        const resp = await axios.put(`${this.BASE_URL}/menu`, formData, {
            headers: {
                ...this.getHeader(),
                'Content-Type': 'multipart/form-data'
            }
        });
        return resp.data;
    }

    static async deleteMenu(id) {
        const resp = await axios.delete(`${this.BASE_URL}/menu/${id}`, {
            headers: this.getHeader()
        });
        return resp.data;
    }

    static async getMenuById(id) {
        const resp = await axios.get(`${this.BASE_URL}/menu/${id}`);
        return resp.data;
    }

    static async getAllMenus() {
        const resp = await axios.get(`${this.BASE_URL}/menu`, {});
        return resp.data;
    }

    static async getAllMenuByCategoryId(categoryId) {
        const resp = await axios.get(`${this.BASE_URL}/menu`, {
            params: {
                categoryId: categoryId
            }
        });
        return resp.data;
    }

    static async searchMenu(search) {
        const resp = await axios.get(`${this.BASE_URL}/menu`, {
            params: {
                search: search
            }
        });
        return resp.data;
    }










    /* CART SECTION */
    static async addItemToCart(cartDTO) {

        const resp = await axios.post(`${this.BASE_URL}/cart/items`, cartDTO, {
            headers: this.getHeader()
        });
        return resp.data;
    }

    static async incrementItem(menuId) {
        const resp = await axios.put(`${this.BASE_URL}/cart/items/increment/${menuId}`, null, {
            headers: this.getHeader()
        });
        return resp.data;
    }

    static async decrementItem(menuId) {
        const resp = await axios.put(`${this.BASE_URL}/cart/items/deccrement/${menuId}`, null, {
            headers: this.getHeader()
        });
        return resp.data;
    }

    static async removeItem(cartItemId) {
        const resp = await axios.delete(`${this.BASE_URL}/cart/items/${cartItemId}`, {
            headers: this.getHeader()
        });
        return resp.data;
    }

    static async getCart() {
        const resp = await axios.get(`${this.BASE_URL}/cart`, {
            headers: this.getHeader()
        });
        return resp.data;
    }

    static async clearCart() {
        const resp = await axios.delete(`${this.BASE_URL}/api/cart`, {
            headers: this.getHeader()
        });
        return resp.data;
    }












    /**REVIEW SECTION */
    static async getMenuAverageOverallReview(menuId) {
        const resp = await axios.get(`${this.BASE_URL}/reviews/menu-item/average/${menuId}`);
        return resp.data;
    }

    static async createReview(body) {
        const resp = await axios.post(`${this.BASE_URL}/reviews`, body, {
            headers: this.getHeader()
        });
        return resp.data;
    }















    // /**PAYMENT SESSION */

    // //funtion to create payment intent
    // static async proceedForPayment(body) {


    //     const resp = await axios.post(`${this.BASE_URL}/payments/pay`, body, {
    //         headers: this.getHeader()
    //     });
    //     return resp.data; //return the resp containg the stripe transaction id for this transaction
    // }

    // //TO UPDATE PAYMENT WHEN IT HAS BEEN COMPLETED
    // static async updateOrderPayment(body) {
    //     const resp = await axios.put(`${this.BASE_URL}/payments/update`, body, {
    //         headers: this.getHeader()
    //     });
    //     return resp.data;
    // }

    // static async getAllPayments() {
    //     const resp = await axios.get(`${this.BASE_URL}/payments/all`, {
    //         headers: this.getHeader()
    //     });
    //     return resp.data;
    // }

    // static async getAPaymentById(paymentId) {
    //     const resp = await axios.get(`${this.BASE_URL}/payments/${paymentId}`, {
    //         headers: this.getHeader()
    //     });
    //     return resp.data;
    // }






}